export default "__VITE_ASSET__X9Wrx$BY__"